import { FC } from 'react';
import { Radio, RadioGroup } from 'components';
import { useTranslation } from 'react-i18next';

interface BooleanFilterProps {
    filter: any;
    setFilter: (data: any) => void;
}

const BooleanFilter: FC<BooleanFilterProps> = ({ filter, setFilter }) => {
    const { t } = useTranslation();

    return (
        <RadioGroup
            value={typeof filter?.value === 'boolean' ? filter.value : ''}
            onChange={(_, value) => setFilter({ value: value === 'true' })}>
            <Radio label={t(`filter_options.true`)} value={true} />
            <Radio label={t(`filter_options.false`)} value={false} />
        </RadioGroup>
    );
};

export default BooleanFilter;
